export default __webpack_public_path__ + "static/media/stair_1.00eb0aee.png";